import cx from "classnames";

import { GridProps } from "./types";

import styles from "./styles.module.css";

export function Component<GridItemProps>(props: GridProps<GridItemProps>) {
  const {
    IterableComponent,
    componentPropsList,
    numberOfColumns = 1,
    adRenderers = [],
    hideScrollbar = true,
  } = props;

  if (!IterableComponent) {
    console.error("No IterableComponent found for Grid");

    return null;
  }

  if (!componentPropsList?.length) {
    console.error(`No props passed in for components in Grid`);

    return null;
  }

  const numberOfRows = Math.min(
    Math.floor(
      (componentPropsList.length + adRenderers.length) / numberOfColumns
    ),
    props.numberOfRows || componentPropsList.length + adRenderers.length
  );

  const iterableComponents = componentPropsList.map((componentProp) => (
    <IterableComponent {...componentProp} />
  ));

  adRenderers.forEach((ad) => {
    if (ad.adPosition > 0) {
      iterableComponents.splice(ad.adPosition - 1, 0, ad.adRenderer());
    } else {
      console.error(`Invalid ad rendering position. adPosition must be >= 1`);
    }
  });

  return (
    <div
      className={cx([
        styles.gridContainer,
        { [styles.hideScrollbar]: hideScrollbar },
      ])}
    >
      {Array(numberOfRows)
        .fill(true)
        .map((_row, rowIndex) => (
          <div key={rowIndex} className={styles.row}>
            {Array(numberOfColumns)
              .fill(true)
              .map((_col, columnIndex) => (
                <div
                  key={rowIndex * numberOfColumns + columnIndex}
                  className={styles.iterableComponent}
                >
                  {iterableComponents[rowIndex * numberOfColumns + columnIndex]}
                </div>
              ))}
          </div>
        ))}
    </div>
  );
}
Component.displayName = "Grid.Component";
